/**
* =========================================================================================
* Component - Filters 
* =========================================================================================
* 
**/

import React, { useState, useEffect } from 'react';
import useWindowSize from '../../../hooks/useWindowSize';
import useEscKey from "ubs-framework/v2/hooks/useEscKey";
import FilterHeaderResp from '../FilterHeaderResp/FilterHeaderResp';
import FilterIcon from '../FilterIcon/FilterIcon';

const UFilters = ({offset, filters, innerFilters, filtersLength, buttons}) => {

    const size = useWindowSize();

    const [allValues, setAllValues] = useState({
        filterOffset: size <= offset,
        mobileFiltersActive: false,
    });

    useEffect(() => {
        if(size > offset && allValues.mobileFiltersActive) { setAllValues({...allValues, filterOffset: false, mobileFiltersActive: false}); }
        else setAllValues({...allValues, filterOffset: size <= offset});
    }, [size]);

    const getFilter = (value) => {
        setAllValues({...allValues, filterOffset: size <= offset, mobileFiltersActive: value});
    }
    
    useEscKey(() => { if(window.innerWidth <= offset) getFilter(false) });

    return (
        <React.Fragment>
            <div className="u_header-filters-list">

                <div className="u_flex u_align-center u_content-end">


                    { allValues?.mobileFiltersActive && <div className="u_filter-content-overlay" onClick={() => getFilter(false)}/> }

                    <div className={`u_filter-content ${allValues?.filterOffset ? 'u_filter-content-mobile' : ''} ${allValues?.mobileFiltersActive ? 'active' : ''}`}>

                        { allValues?.mobileFiltersActive && <FilterHeaderResp getFilter={getFilter} filters={filtersLength} /> }

                        <div className={`u_filter-content-inner`}>

                            { filters }
                            
                            { allValues?.mobileFiltersActive && innerFilters }

                        </div>    
                    </div>    

                    {/* Mobile Filter icon */}
                    { allValues?.filterOffset && <FilterIcon filters={filtersLength} getFilter={getFilter} /> }

                    { buttons }
                </div>
            </div>
        </React.Fragment>
    )
}

export default UFilters;
